(function (angular) {
  angular.module('xplenty-designer').factory('DesignerUnionComponent', [
    'DesignerComponent',
    'DesignerSchema',

    function (DesignerComponent, DesignerSchema) {
      function DesignerUnionComponent() {
        DesignerComponent.apply(this);

        this.fields = [];
      }

      DesignerUnionComponent.prototype = new DesignerComponent();

      DesignerUnionComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          fields: this.fields,
        });

        return data;
      };

      DesignerUnionComponent.prototype.setFormData = function (data) {
        this.fields = data.fields;

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerUnionComponent.prototype.setData = function (data) {
        if (data.fields) this.fields = data.fields;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerUnionComponent.prototype.getSchema = function () {
        const schema = new DesignerSchema();

        schema.id = this.id;
        schema.name = this.name;

        if (this.inputEdges.length >= 2) {
          _.each(this.fields, function (field) {
            schema.fields.push({
              name: field.alias,
            });
          });
        }

        return schema;
      };

      return DesignerUnionComponent;
    },
  ]);
})(window.angular);
